import { GetReadyForAssignmentActionTypes, GetReadyForAssignmentDataState, GET_READY_FOR_ASSIGNMENT_FAILURE, GET_READY_FOR_ASSIGNMENT_REQUEST, GET_READY_FOR_ASSIGNMENT_SUCCESS } from "./types";

const defaultState: GetReadyForAssignmentDataState = {
  isLoading: false,
  errorMessage: ""
};

export default function getReadyForAssignmentData(state = defaultState, action: GetReadyForAssignmentActionTypes): GetReadyForAssignmentDataState {
  switch (action.type) {
    case GET_READY_FOR_ASSIGNMENT_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case GET_READY_FOR_ASSIGNMENT_SUCCESS:
      return {
        ...state,
        contents: action.contents,
        isLoading: false,
        errorMessage: ""
      };
    case GET_READY_FOR_ASSIGNMENT_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMessage: ""
      };
    default:
      return state;
  }
};